module.exports = __webpack_public_path__ + "static/ssb-day3-d2ece37fa0ed8fcc4a0d3ae5608067de.png";